import { create } from "zustand";

type NotificationStoreState = {
    showCreateNotificationDialog: boolean;
};

type NotificationStoreActions = {
    actions: {
        updateShowCreateNotificationDialog: (val?: boolean) => void;
    };
};

export const useNotificationsStore = create<NotificationStoreState & NotificationStoreActions>()((set) => ({
    showCreateNotificationDialog: false,
    actions: {
        updateShowCreateNotificationDialog: (val) => set({ showCreateNotificationDialog: val ?? false }),
    },
}));

export const useNotificationShowCreateDialog = () =>
    useNotificationsStore((state) => state.showCreateNotificationDialog);

export const useNotificationActions = () => useNotificationsStore((state) => state.actions);
